<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<!--el-form-item 自定义label  -->
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" filterable>
						<el-option label="全选" value="0" key="0"></el-option>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.name" placeholder="用户名称"></el-input>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow  AddButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="devices" highlight-current-row v-loading="listLoading"  style="width: 100%;" border  :height="formHeight" size="mini">
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="name" label="用户名称">
			</el-table-column>
			<el-table-column prop="projectName" label="项目名称" >
                <template slot-scope="scope">
					<span>{{projectMap.get(scope.row.projectId)}}</span>
				</template>
			</el-table-column>
            <el-table-column prop="clientId" label="唯一标识">
			</el-table-column>
            <el-table-column prop="clientSecret" label="秘钥" >
			</el-table-column>
			<el-table-column prop="startTime" label="开始时间" >
			</el-table-column>
            <el-table-column prop="expiryDate" label="到期时间">
			</el-table-column>
            <el-table-column prop="state" label="状态">
                <template slot-scope="scope">
					<span v-if="scope.row.state==0" style="color:green">允许</span>
					<span v-else style="color:red">禁止</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[20,50,100,200]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--From界面-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false" width="60%" top="10vh">
			<div class="formStyle">
				<el-form :model="formdevice" label-width="120px" :rules="formRules" ref="formdevice" >
					<el-form-item label="用户名称" prop="name">
						<el-input v-model="formdevice.name" ></el-input>
					</el-form-item>
					<el-form-item label="项目名称"  prop="projectId">
						<el-select v-model="formdevice.projectId" placeholder="请选择项目名称" filterable>
							<el-option
								v-for="item in projects"
								:label="item.name"
								:value="item.projectId" :key="item.projectId">
							</el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="唯一标识" prop="clientId" v-if="type=='修改'">
						<el-input v-model="formdevice.clientId"  disabled></el-input>
					</el-form-item>
                    <el-form-item label="秘钥" prop="clientSecret" v-if="type=='修改'">
						<el-input v-model="formdevice.clientSecret"  disabled></el-input>
					</el-form-item>
					<el-form-item label="开始时间" prop="startTime" v-if="type=='修改'" >
						<el-date-picker v-model="formdevice.startTime" align="right" type="date"  disabled> </el-date-picker>
					</el-form-item>
                    <el-form-item label="到期时间" prop="expiryDate" v-if="type=='修改'">
						<el-date-picker v-model="formdevice.expiryDate" align="right" type="date" format="yyyy-MM-dd"  value-format="yyyy-MM-dd"> </el-date-picker>
					</el-form-item>
                    <el-form-item label="状态" v-if="type=='修改'" >
                        <el-switch v-model="formdevice.state" active-value='0' inactive-value='1' ></el-switch>
                    </el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="cancleSubmit">取消</el-button>
					<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
				</div>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import {insertSha256CheckDigit,updateSha256CheckDigit,selectSha256CheckDigit,getProjects} from '../../api/api';

	import myButton from '../../components/myButton/index.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
	components: { myButton,TableUpdateButton},
		data() {
			return {
				filters: {
                    name: '',
                    projectId:'0'
				},
				devices: [],
				total: 0,
               	page:1,
				pageSize:50,
				listLoading: false,

				formVisible: false,//修改界面是否显示
				loading: false,
                formRules: {
					name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
					],
                    projectId: [
						{  required: true, message: '请选择项目', trigger: 'change'}
					]
				},

				formHeight:0,
				//界面数据
				formdevice: {},
				type:'新增',
				length:0,
				usertype:sessionStorage.getItem("type"),
				sn:'',
				mn:'',
                projects:[],
                projectMap:new Map()
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getSha256CheckDigit();
				}else if(type=="add"){
					this.handleAdd();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getSha256CheckDigit();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getSha256CheckDigit();
			},
			//获取数据列表
			getSha256CheckDigit() {
				let para = {
                    page: this.page,
                    pageSize:this.pageSize,
                    name: this.filters.name,
					projectId:this.filters.projectId
				};
                this.listLoading = true;
				selectSha256CheckDigit(para).then((res) => {
                    this.listLoading = false;
					if(res.data.Result=="layout"){
                        this.$message({
                            message: "用户已离线，请重新登录",
                            type: 'error'
                        })
						this.$router.push({ path: '/login' });
						return;
                    }
					this.total = res.data.count;
					this.devices = res.data.data;
				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.facShow=false;
				this.formVisible = true;
				if( this.$refs.formdevice!=undefined){
               		this.$refs.formdevice.resetFields();
				}
				this.type='修改';
				this.formdevice = Object.assign({}, row);
                this.formdevice.state=row.state.toString();
			},
			//显示新增界面
			handleAdd: function () {
				this.facShow=false;
				this.formVisible = true;
				this.type='新增';
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.getSha256CheckDigit();

						for (let index = 0; index < this.projects.length; index++) {
							const element = this.projects[index];
							this.projectMap.set(element.projectId,element.name);
						}
					}
				});
			},
            //Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
                     this.addSubmit();
                }
			},
			//添加
			addSubmit: function () {
				this.$refs.formdevice.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
                            let param = new URLSearchParams();
                            param.append('name', this.formdevice.name);
                            param.append('projectId',this.formdevice.projectId);

                            insertSha256CheckDigit(param).then((res) => {
								this.loading = false;
                               	let resData = res.data;
								if (resData != true) {
									this.$message({
									message: '添加失败',
									type: 'error'
								})}else{
									this.$message({
										message: '添加成功',
										type: 'success'
									});
								}
                                this.formVisible = false;                                
                                this.getSha256CheckDigit();
                            }).catch(err => {
                                this.loading = false;
                                this.$message({
                                    message: "操作失败，请重试",
                                    type: 'error'
                                });
                            })
						});
					}
				});
            },
            //修改
			editSubmit: function () {
				this.$refs.formdevice.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
                            let param = new URLSearchParams();
                            param.append('name', this.formdevice.name);
                            param.append('projectId',this.formdevice.projectId);
                            param.append('expiryDate',this.formdevice.expiryDate);
                            param.append('state',this.formdevice.state);
                            param.append('id',this.formdevice.id);

                            updateSha256CheckDigit(param).then((res) => {
								this.loading = false;
                               	let resData = res.data;
								if (resData != true) {
									this.$message({
									message: '修改失败',
									type: 'error'
								})}else{
									this.$message({
										message: '修改成功',
										type: 'success'
									});
								}
                                this.formVisible = false;                                
                                this.getSha256CheckDigit();
                            }).catch(err => {
                                this.loading = false;
                                this.$message({
                                    message: "操作失败，请重试",
                                    type: 'error'
                                });
                            })
						});
					}
				});
			},
            //取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				this.formHeight=hgt-titleHgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)                                                 
			this.getProjects(); 
		}
	}

</script>

<style scoped>

	.dialog-footer{
		text-align: right;
	}
	.isShow{
		display: block;
	}
	.notShow{
		display: none;
	}


	
</style>


// WEBPACK FOOTER //
// CheckDigitMa.vue?8a40dee4